import { useMutation } from 'react-query';
import { network } from 'services/network';

const sendForgotPasswordEmail = (params) => {
    const url = `admin/bo/resendInviteEmail?userEmail=${encodeURIComponent(params)}`;
    return network
        .post(url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error === 'Request failed with status code 404') {
                throw new Error('invalid email!');
            } else {
                throw error;
            }
        });
};

const useResendInviteMutation = () => {
    return useMutation<unknown, QueryError, string>((params) => sendForgotPasswordEmail(params));
};

export { useResendInviteMutation };
